import { Link } from 'react-router-dom';
import { LOGO_SRC } from './Header';
import { Star } from '../icons/WhatsAppIcon';

const CLAIMS = [
  'Alle Systeme deiner Gastronomie an einem Ort',
  'Persönlicher Support statt Warteschleife',
  'Herstellerneutral, transparent, auf Augenhöhe',
];

// Zweispaltiger Rahmen für Login, Registrierung, Passwort & Co.
export const AuthShell = ({ eyebrow, title, intro, children, below, maxWidth = 'max-w-md', testId }) => (
  <div className="min-h-screen bg-off" data-testid={testId}>
  <div className="min-h-screen lg:grid lg:grid-cols-12">
    <aside className="lg:col-span-5 sec--deep relative overflow-hidden flex flex-col px-5 py-4 lg:px-12 lg:py-12 lg:min-h-screen border-b-2 lg:border-b-0 lg:border-r-2 border-ink">
      <Link to="/" className="inline-flex self-start bg-off border-2 border-lilac p-2.5 pr-3 relative z-10" aria-label="Zur Startseite" data-testid="auth-logo-link">
        <img src={LOGO_SRC} alt="gastro-beratung.de" width="600" height="108" className="h-7 sm:h-8 w-auto" />
      </Link>
      <div className="hidden lg:block mt-20 relative z-10">
        <p className="eyebrow text-lilac mb-6"><Star className="text-lilac" />Kundenplattform</p>
        <h2 className="display-2 text-off max-w-[15ch]">
          Deine digitale Gastro-Landschaft <span className="serif-it text-lilac">– an einem Ort.</span>
        </h2>
        <ul className="rule-list rule-list--off mt-10 max-w-md">
          {CLAIMS.map((claim) => (
            <li key={claim} className="flex items-center gap-3 text-off/90">
              <span className="text-lilac" aria-hidden="true">✳</span>
              {claim}
            </li>
          ))}
        </ul>
      </div>
      <p className="hidden lg:block mt-auto pt-16 text-off/60 text-sm relative z-10">
        © {new Date().getFullYear()} GND Gastro Next Digital UG
      </p>
      <div aria-hidden="true" className="hidden lg:block absolute -bottom-40 -right-40 w-[24rem] h-[24rem] rounded-full bg-purple border-2 border-lilac/30" />
    </aside>

    <main className="lg:col-span-7 flex items-start lg:items-center justify-center px-4 py-10 lg:py-16">
      <div className={`w-full ${maxWidth}`}>
        <header className="mb-8">
          {eyebrow && <p className="eyebrow mb-4"><Star />{eyebrow}</p>}
          <h1 className="display-3">{title}</h1>
          {intro && <p className="text-ink/80 mt-3 text-base sm:text-lg max-w-[52ch]">{intro}</p>}
        </header>
        <div className="card-ink card-ink--shadow p-6 sm:p-8">{children}</div>
        {below && <div className="mt-6 text-center">{below}</div>}
      </div>
    </main>
  </div>
  </div>
);

// Icon-Kachel im Kartenkopf (Erfolg, Fehler, Wartend)
export const AuthIcon = ({ tone = 'purple', children }) => {
  const tones = {
    purple: 'bg-lilac text-purple',
    green: 'bg-green-100 text-green-700',
    red: 'bg-red-100 text-red-700',
    amber: 'bg-amber-100 text-amber-700',
  };
  return (
    <div className={`w-16 h-16 border-2 border-ink flex items-center justify-center mx-auto mb-4 ${tones[tone]}`}>
      {children}
    </div>
  );
};

export default AuthShell;
